import { ThemeProvider } from '@mui/material';
import { onMessage } from 'firebase/messaging';
import isEmpty from 'lodash-es/isEmpty';
import { useEffect, useState } from 'react';
import { setLicenseKey } from 'survey-core';
import { csrfTokenCall } from 'wisestep-api';
import { theme } from 'wisestep-base';

import FcmNotification from './components/FCMNotification/FcmNotifcation';
import CustomNotification from './components/notification';
import { WorkspaceContextProvider } from './context';
import { messaging } from './firebase/firebase';
import { useNotificationCount } from './hooks/useNotificationCount';
import { authInterceptor } from './interceptor/authInterceptor';
import { AppProvider } from './providers/App';
import { AppRoutes } from './routes';
import { getWorkspaceToken } from './utils/token';

setLicenseKey('ODQyNjI4ZjEtZWU2ZC00MzlkLWEzNmItNmE2MjUwOWFlMzk2OzE9MjAyNC0xMC0yNg==');

function App() {
  authInterceptor();

  type NotificationData = {
    title: string;
    body: string;
    link: string;
  };

  const [notification, setNotification] = useState<NotificationData | null>(null);
  const { refresh: refreshCount } = useNotificationCount();

  useEffect(() => {
    if (isEmpty(getWorkspaceToken())) {
      csrfTokenCall();
    }
  });

  useEffect(() => {
    if (!messaging) {
      console.error('Firebase messaging not initialized');
      return;
    }

    console.log('Setting up onMessage handler...');

    const unsubscribe = onMessage(messaging, async (payload) => {
      console.log('[Foreground FCM Message received at]:', new Date().toISOString());
      console.log('Payload:', JSON.stringify(payload, null, 2));

      let notificationData;
      if (payload.notification) {
        notificationData = {
          title: payload.notification.title || 'New Message',
          body: payload.notification.body || '',
          link: payload.data?.link || 'https://wisestep.com/',
        };
      } else if (payload.data) {
        notificationData = {
          title: payload.data.title || 'New Message',
          body: payload.data.body || '',
          link: payload.data.link || 'https://wisestep.com/',
        };
      }

      if (notificationData) {
        console.log('Setting notification:', notificationData);
        setNotification(notificationData);
        try {
          await refreshCount();
        } catch (err) {
          console.error('Failed to refresh notification count:', err);
        }
      }
    });
    return () => unsubscribe();
  }, [refreshCount]);

  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <WorkspaceContextProvider>
          <FcmNotification notification={notification} />
          <CustomNotification />
          <AppRoutes />
        </WorkspaceContextProvider>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
